import { create } from 'zustand';

export default create((set) => ({
    scopeNav: null, // { scopes: [...], currentScope: 'slug', isCompte: bool }
    setScopeNav: (nav) => set({ scopeNav: nav }),
    clearScopeNav: () => set({ scopeNav: null }),
    // Une page occupe le coin du bouton flottant « Feedback » (ex. « Débloquer l'accès » d'une thématique
    // pour un compte gratuit) : le bouton se masque, le formulaire reste ouvrable par 'feedback:open'.
    feedbackFabHidden: false,
    setFeedbackFabHidden: (hidden) => set({ feedbackFabHidden: hidden }),
}));
